import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { NotificationDeliveryLog, NotificationDeliveryLogCreate, NotificationDeliveryLogFilter } from '../data/notificationDeliveryLog';

export function createNotificationDeliveryLogService(client: AxiosInstance) {
  return createCrudService<NotificationDeliveryLog, NotificationDeliveryLogCreate, NotificationDeliveryLogFilter>(
    client,
    '/notifications/NotificationDeliveryLog',
    'id',
  );
}

export type NotificationDeliveryLogService = CrudService<NotificationDeliveryLog, NotificationDeliveryLogCreate, NotificationDeliveryLogFilter>;
